import { Injectable } from '@angular/core';
import { Plugins } from '@capacitor/core';
import { NativeBiometric } from 'capacitor-native-biometric';
import { AuthService } from './auth.service';
import { ILoginCredentials } from '../models/login-credentials.interface';

@Injectable({
    providedIn: 'root',
})
export class BiometricService {
    credentials!: { username: string; password: string };

    constructor(private authService: AuthService) {}

    verifyIdentity() {
        console.log('verificando identidad servicio...');
        NativeBiometric.verifyIdentity({
            reason: 'For easy log in',
            title: 'Log in',
            subtitle: 'Authenticate',
            description: 'Please authenticate to proceed',
            maxAttempts: 2,
            useFallback: true,
        })
            .then(() => true)
            .catch(() => false);
    }

    async saveCredentials(credentials: ILoginCredentials) {
        console.log('guardando credenciales servicio...');
        try {
            await NativeBiometric.setCredentials({
                username: credentials.email,
                password: credentials.password,
                server: 'tech.advisoryservicesg.ecosistema',
            });
        } catch (e) {
            console.log(e);
        }
    }

    async getCredentials() {
        console.log('obteniendo credenciales servicio...');
        try {
            this.credentials = await NativeBiometric.getCredentials({
                server: 'tech.advisoryservicesg.ecosistema',
            });
        } catch (e) {
            console.log(e);
        }
    }

    async deleteCredentials() {
        console.log('borrando credenciales servicio...');
        return NativeBiometric.deleteCredentials({
            server: 'tech.advisoryservicesg.ecosistema',
        });
    }
}
